import React, { useEffect } from 'react'
import { useIntl } from 'react-intl'
import { useFormContext } from 'react-hook-form'

import { formatErrorMessage } from 'helpers/contactRequestForm'

import Select from 'components/Form/Select'
import FormattedMessage from 'components/FormattedMessage'

import { useUserProjectsQuery } from '../graphql.generated'

import { ProjectsDropdownProps } from '../types'

const ProjectsDropdown: React.FC<ProjectsDropdownForCustomers> = (props) => {
  const {
    initialValue,
    className = '',
    withEmptyOptions,
    selectDropdownClassName = '',
    optionWrapper,
  } = props

  const {
    loading,
    error,
    data: {
      projects = [],
    } = {},
  } = useUserProjectsQuery()

  const intl = useIntl()

  const form = useFormContext()
  const value = form.watch('projectId')

  useEffect(() => {
    if (!loading && !value && projects && !error) {
      const searchedProject = Number(initialValue) &&
        projects.find(project => String(project.id) === String(initialValue))

      let projectId

      if (searchedProject && searchedProject.id) {
        projectId = searchedProject.id?.toString()
      } else if (withEmptyOptions) {
        projectId = '0'
      } else {
        projectId = projects[0]?.id
      }

      if (projectId) {
        form.setValue('projectId', projectId)
      }
    }
  }, [loading, value, initialValue, projects, error])

  return (
    <Select
      name="projectId"
      rules={{ required: formatErrorMessage(intl, 'selectEvent') }}
      disabled={loading}
      defaultActiveFirstOption={true}
      placeholder={loading ? intl.formatMessage({ id: 'common.loading' }) : null}
      className={className}
      dropdownClassName={selectDropdownClassName}
    >
      {withEmptyOptions && (
        <Select.Option key="newProject" value="0">
          <FormattedMessage id="newHeader.navigation.projectSelector.newProject" />
        </Select.Option>
      )}
      {projects?.map((project) => (
        <Select.Option key={project.id} value={project.id}>
          {optionWrapper ? optionWrapper(project) : project.title}
        </Select.Option>
      ))}
    </Select>
  )
}

type ProjectsDropdownForCustomers = ProjectsDropdownProps

export default ProjectsDropdown
